import type { FileType } from '@/types/dtos/media/media.asset.dto.ts';

const EXTENSION_TO_FILE_TYPE: Readonly<Record<string, FileType>> = {
  pptx: 'presentation',
  ppt: 'presentation',
  pdf: 'pdf',
  mp4: 'video',
  mov: 'video',
  webm: 'video',
  avi: 'video',
  mkv: 'video',
  mp3: 'audio',
  wav: 'audio',
  ogg: 'audio',
  aac: 'audio',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  webp: 'image',
  bmp: 'image',
};

export function inferMediaFileTypeFromFileName(fileName: string): FileType | undefined {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension) {
    return undefined;
  }
  return EXTENSION_TO_FILE_TYPE[extension];
}
